<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon new">
      <i class="fa-solid fa-film"></i>
    </div>
    <div>
      <h2 class="dialog-title">Media Player</h2>
      <p class="dialog-subtitle">View media content for {{ decodeObjectType() }} {{ data.identifier }}</p>
    </div>
  </div>
  <button class="dialog-close" (click)="onCancel()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <div class="video-player-container" #videoPlayerContainer (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <video #videoPlayer
      (click)="togglePlayPause()"
      (loadedmetadata)="onLoadedMetadata()"
      (contextmenu)="false;">
      <source src="" type="video/mp4">
      Your browser does not support the video tag.
    </video>

    <div class="video-controls" [class.visible]="showControls">
      <div class="progress-bar-container" (click)="seek($event)">
        <div class="progress-bar">
          <div class="progress-filled" [style.width.%]="progress"></div>
        </div>
      </div>

      <div class="controls-bottom">
        <div class="controls-left">
          <button class="control-btn" (click)="togglePlayPause()">
            <i [class]="isPlaying ? 'fa-solid fa-pause' : 'fa-solid fa-play'"></i>
          </button>
          <button class="control-btn" (click)="toggleMute()">
            <i [class]="isMuted ? 'fa-solid fa-volume-xmark' : 'fa-solid fa-volume-high'"></i>
          </button>
          <input type="range" class="volume-slider" min="0" max="100" [value]="volume" (input)="setVolume($event)">
          <div class="time-display" [cdkCopyToClipboard]="formatTime(currentTime)" (click)="onCopyTimecode(formatTime(currentTime))" matTooltip="Copy Timecode">
            {{ formatTime(currentTime) }} / {{ formatTime(duration) }}
          </div>
        </div>

        <div class="controls-right">
          <button class="control-btn" (click)="toggleFullscreen()">
            <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  @if( data.mediaDownloadAllowed ) {
    <button class="btn-ghost" (click)="onDownloadMedia()">Download Media</button>
  }
  <button class="btn-ghost" (click)="onCancel()">Close</button>
</mat-dialog-actions>
